(function () {
  'use strict';

  const instances = Array.from(document.querySelectorAll('[data-bundle-progress]'));
  if (!instances.length) return;

  const BUNDLE_MAX = 3;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && Shopify.money_format) {
      try { return Shopify.formatMoney(cents, Shopify.money_format); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function readConfig(el) {
    const saleStr = el.dataset.saleVariants || '';
    const saleVariants = new Set(
      saleStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean)
    );
    return {
      matchType: (el.dataset.matchType || '').toLowerCase(),
      matchTag: (el.dataset.matchTag || '').toLowerCase().trim(),
      discount2: parseFloat(el.dataset.discount2) || 0,
      discount3: parseFloat(el.dataset.discount3) || 0,
      productPrice: parseInt(el.dataset.productPrice, 10) || 0,
      deliveryText: el.dataset.deliveryText || '',
      unitWord: el.dataset.unitWord || '',
      saleVariants: saleVariants,
      headlines: [
        el.dataset.headline0 || '',
        el.dataset.headline1 || '',
        el.dataset.headline2 || '',
        el.dataset.headline3 || '',
      ],
      savingsLabel: el.dataset.savingsLabel || "You're saving",
      // 'bundle' = savings on matching items only (default, PDP/collection bars).
      // 'cart'   = whole-cart savings (original_total_price - total_price), used
      //            by the upsell popup so the number matches the cart drawer.
      savingsScope: el.dataset.savingsScope || 'bundle',
      slotSavingsFormat: el.dataset.slotSavingsFormat || 'percent',
      showCheckmarks: el.dataset.showCheckmarks === '1',
      tierDefaults: [
        el.dataset.tier1Savings || '',
        el.dataset.tier2Savings || '',
        el.dataset.tier3Savings || '',
      ],
    };
  }

  // Toggle button: collapse/expand
  function wireToggle(el) {
    const btn = el.querySelector('[data-bpb-toggle]');
    if (!btn) return;
    if (btn.dataset.bpbToggleWired) return; // belt-and-braces: skip if already wired
    btn.dataset.bpbToggleWired = '1';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      el.classList.toggle('bpb--collapsed');
    });
  }

  // Close button: dismiss for the current session
  function wireClose(el) {
    const btn = el.querySelector('[data-bpb-close]');
    if (!btn) return;
    if (btn.dataset.bpbCloseWired) return;
    btn.dataset.bpbCloseWired = '1';
    const key = 'bpb-dismissed-' + el.id;
    try {
      if (sessionStorage.getItem(key) === '1') {
        el.classList.add('bpb--dismissed');
      }
    } catch (e) {}
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      el.classList.add('bpb--dismissed');
      try { sessionStorage.setItem(key, '1'); } catch (e) {}
    });
  }

  const DESKTOP_MIN = 1280;

  // Remove ONLY wrappers whose bar has a duplicate elsewhere in the DOM (typical
  // when the theme editor re-renders the section — Shopify creates a fresh bar
  // inside the section while the moved-out one lingers in .collection__content).
  // We never remove a wrapper that's the only instance of its bar.
  function cleanupOrphans() {
    document.querySelectorAll('sticky-element.bpb-sticky-wrapper').forEach(function (w) {
      const bar = w.querySelector('[data-bundle-progress]');
      if (!bar) { w.remove(); return; }
      const all = document.querySelectorAll('[data-bundle-progress][id="' + bar.id + '"]');
      if (all.length > 1) {
        // A duplicate exists in a section — this wrapper is stale, drop it
        w.remove();
      }
    });
  }

  // Inline-sidebar mode: when desktop_position is "sidebar-left" or "sidebar-right",
  // move the bar element into the collection's flex content container so it takes
  // a column next to the products (same pattern as Concept's native filter sidebar).
  //
  // The bar is wrapped in Concept's <sticky-element> so its sticky offset respects
  // the sticky header height — fixes the "top of bar gets clipped" issue while scrolling.
  function mountAsSidebar(el) {
    const cls = el.classList;
    const wantsLeft  = cls.contains('bpb--desktop-sidebar-left');
    const wantsRight = cls.contains('bpb--desktop-sidebar-right');
    if (!wantsLeft && !wantsRight) return;

    // Only inline-sidebar on desktop. On mobile the plain .bpb--sticky CSS
    // (fixed bottom, full width) handles things — don't touch the DOM.
    if (window.innerWidth < DESKTOP_MIN) return;

    // Don't re-mount if this bar is already wrapped in a sticky-wrapper.
    if (el.closest('sticky-element.bpb-sticky-wrapper')) return;

    const content = document.querySelector('.collection__content');
    if (!content) return; // not a collection page — bar stays in place

    // Wrap in <sticky-element class="xl:sticky bpb-sticky-wrapper">
    const wrapper = document.createElement('sticky-element');
    wrapper.className = 'xl:sticky bpb-sticky-wrapper';
    wrapper.setAttribute('data-gap', '20');
    wrapper.appendChild(el);

    if (wantsLeft) {
      content.insertBefore(wrapper, content.firstChild);
    } else {
      content.appendChild(wrapper);
    }

    el.classList.add('bpb--in-sidebar');

    // Trigger the column-reduction CSS on the .collection wrapper
    const collection = document.querySelector('.collection');
    if (collection) collection.classList.add('with-bundle-sidebar');
  }

  // Flat array of cart line "units" matching the product_type, one entry per
  // quantity. On-sale items are EXCLUDED — the bundle promo isn't supposed to
  // stack on items already discounted via compare_at_price, and counting them
  // would mislead the customer.
  //
  // Two-tier detection:
  //   PRIMARY  — variant_id is in the server-rendered sale-variants list
  //              (Liquid loops the current collection's products and emits
  //              every variant where compare_at_price > price). This works
  //              reliably even when /cart.js omits compare_at_price.
  //   FALLBACK — item.compare_at_price > current price, when /cart.js does
  //              expose that field on this storefront.
  // ---- Product-tag lookup (for tag-gated bundles, e.g. only "Graphics" tees).
  // /cart.js line items do NOT include product tags, so we fetch
  // /products/{handle}.js once per handle and cache the lowercased tag list.
  // null = lookup failed -> fail OPEN (count the item) so a hiccup never
  // hides legitimate bundle progress.
  const productTagCache = new Map(); // handle -> string[] | null

  async function prefetchTags(handles) {
    const unknown = handles.filter(function (h) { return h && !productTagCache.has(h); });
    await Promise.all(unknown.map(async function (handle) {
      try {
        const res = await fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) { productTagCache.set(handle, null); return; }
        const data = await res.json();
        const tags = Array.isArray(data.tags) ? data.tags.map(function (t) { return String(t).toLowerCase().trim(); }) : [];
        productTagCache.set(handle, tags);
      } catch (e) {
        productTagCache.set(handle, null);
      }
    }));
  }

  function itemHasTag(item, matchTag) {
    if (!matchTag) return true; // no tag filter configured
    const tags = productTagCache.get(item.handle);
    if (tags == null) return true; // unknown / fetch failed -> fail open
    return tags.indexOf(matchTag) !== -1;
  }

  function flattenMatchingItems(cart, matchType, saleVariants, matchTag) {
    if (!cart || !Array.isArray(cart.items)) return [];
    const out = [];
    cart.items.forEach(function (item) {
      const type = (item.product_type || '').toLowerCase();
      if (type !== matchType) return;
      if (!itemHasTag(item, matchTag)) return;

      const unitPrice = item.final_price || item.price || 0;

      // Primary: variant_id is on the server-rendered sale list
      if (saleVariants && saleVariants.has(String(item.variant_id))) return;

      // Fallback: cart.js exposed compare_at_price and it indicates a sale
      const cmp = item.compare_at_price || 0;
      if (cmp > 0 && cmp > unitPrice) return;

      // original (full) and final (actually paid) unit prices. Shopify already
      // applied the bundle/automatic discount, so final_price reflects it —
      // never re-apply the discount % on top of it.
      const originalPrice = (item.original_price != null ? item.original_price : item.price) || 0;
      const paidPrice = (item.final_price != null ? item.final_price : item.price) || 0;

      const img = item.image || (item.featured_image && item.featured_image.url) || '';
      const title = item.product_title || item.title || '';
      const qty = item.quantity || 0;
      for (let i = 0; i < qty; i++) {
        out.push({ title: title, image: img, price: originalPrice, finalPrice: paidPrice });
      }
    });
    return out;
  }

  // Request a sized CDN variant of the image.
  function resizeImage(url, size) {
    if (!url || typeof url !== 'string') return url;
    let u = url.startsWith('//') ? 'https:' + url : url;
    return u.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + 'x$1$2');
  }

  function currentDiscountPct(count, cfg) {
    if (count >= 3) return cfg.discount3;
    if (count === 2) return cfg.discount2;
    return 0;
  }

  function slotSavingsText(item, count, cfg) {
    const pct = currentDiscountPct(count, cfg);
    if (cfg.slotSavingsFormat === 'none') return '';
    if (cfg.slotSavingsFormat === 'amount') {
      const paid = item.finalPrice != null ? item.finalPrice : (item.price || 0);
      const cents = Math.max(0, (item.price || 0) - paid);
      return cents > 0 ? formatMoney(cents) + ' off' : 'Full Price';
    }
    // default: percent
    return pct > 0 ? pct + '% off' : 'Full Price';
  }

  // Per-tier price projection for the PDP layout. Static — driven by the
  // product's base price + the tier's discount %, not the cart state.
  function tierPriceText(slotIndex, cfg) {
    if (!cfg.productPrice) return '';
    let pct = 0;
    if (slotIndex === 1) pct = cfg.discount2;
    else if (slotIndex === 2) pct = cfg.discount3;
    const unitCents = Math.round(cfg.productPrice * (1 - pct / 100));
    return formatMoney(unitCents) + (cfg.unitWord ? ' /' + cfg.unitWord : '');
  }

  // Cart-based average price actually paid per unit at the current tier.
  // total paid = subtotal - bundle savings; average = total paid / count.
  function avgPerTeeText(items, count, cfg) {
    if (!count) return '';
    // Average price ACTUALLY paid per unit — sum of final_price (already includes
    // the bundle/automatic discount) divided by the number of units.
    const totalPaid = items.reduce(function (s, it) {
      return s + (it.finalPrice != null ? it.finalPrice : (it.price || 0));
    }, 0);
    const avgCents = Math.round(totalPaid / count);
    const unit = cfg.unitWord || 'tee';
    return formatMoney(avgCents) + ' /' + unit;
  }

  // Mirror the bundle state into the native Add-to-Cart button (separate block).
  // Additive + null-guarded; never touches the button's form/submit behavior.
  //   - [data-bpb-cart-total]: the selected variant's unit price (variant-aware
  //     via cfg.productPrice, which is refreshed on variant change).
  //   - [data-bpb-cart-sub]: the Liquid-computed delivery estimate (if set).
  // Visual swaps (uppercase, hide icon, show price) are pure CSS via :has().
  function updateButton(cfg) {
    if (cfg.productPrice) {
      const priceText = formatMoney(cfg.productPrice);
      document.querySelectorAll('[data-bpb-cart-total]').forEach(function (node) {
        node.textContent = priceText;
      });
    }
    if (cfg.deliveryText) {
      document.querySelectorAll('[data-bpb-cart-sub]').forEach(function (node) {
        node.textContent = cfg.deliveryText;
      });
    }
  }

  function render(el, items, cart) {
    const cfg = readConfig(el);
    const count = items.length;
    const tier = count >= 3 ? 3 : count;

    // ----- Track fill: discrete by segment -----
    //   0–1 shirts → 0% (no segment filled)
    //   2 shirts   → 50% (first segment between slots 1 and 2)
    //   3+ shirts  → 100% (both segments filled)
    let fillPct = 0;
    if (count >= 3) fillPct = 100;
    else if (count === 2) fillPct = 50;
    // Use a CSS custom property on the root so the fill width can't be undone by other inline-style writes.
    el.style.setProperty('--bpb-fill-pct', fillPct + '%');
    const fillEl = el.querySelector('[data-bpb-fill]');
    if (fillEl) fillEl.style.width = fillPct + '%';

    // ----- Slots: images, savings text, filled state -----
    const slots = el.querySelectorAll('.bpb__slot');
    // The pdp layout puts savings spans in their own row (outside the slot
    // wrapper). Fall back to a global, DOM-order list when the slot doesn't
    // contain its own savings element.
    const allSavingsEls = el.querySelectorAll('[data-bpb-slot-savings]');
    slots.forEach(function (slot, i) {
      const item = items[i];
      const empty = slot.querySelector('.bpb__slot-empty');
      const img = slot.querySelector('[data-bpb-slot-img]');
      const check = slot.querySelector('[data-bpb-slot-check]');
      const savingsEl = slot.querySelector('[data-bpb-slot-savings]') || allSavingsEls[i];

      slot.classList.toggle('bpb__slot--filled', !!item);
      slot.classList.toggle('bpb__slot--unlocked', i < count);

      if (item && item.image) {
        const src = resizeImage(item.image, 120);
        if (img.getAttribute('src') !== src) {
          img.setAttribute('src', src);
          img.setAttribute('alt', item.title || '');
        }
        img.hidden = false;
        if (empty) empty.style.display = 'none';
      } else {
        img.hidden = true;
        img.removeAttribute('src');
        if (empty) empty.style.display = '';
      }

      // Check badge (only present in DOM when enabled)
      if (check) check.hidden = !item;

      // Per-slot savings text
      if (savingsEl) {
        if (cfg.slotSavingsFormat === 'price_per_unit') {
          // PDP layout: static per-tier projected unit price, independent of cart state
          savingsEl.textContent = tierPriceText(i, cfg);
        } else if (cfg.slotSavingsFormat === 'per_tee') {
          // Cart-based average price paid per unit, once 2+ qualify for a discount
          if (item && count >= 2) {
            savingsEl.textContent = avgPerTeeText(items, count, cfg);
          } else if (item) {
            savingsEl.textContent = 'Full Price';
          } else {
            savingsEl.textContent = savingsEl.dataset.tierDefault || cfg.tierDefaults[i] || '';
          }
        } else if (item) {
          savingsEl.textContent = slotSavingsText(item, count, cfg);
        } else {
          // Empty slot — show the static tier label as set in theme editor
          savingsEl.textContent = savingsEl.dataset.tierDefault || cfg.tierDefaults[i] || '';
        }
      }
    });

    // ----- Total savings (all matching items in cart) -----
    // Actual savings = full (original) total minus what's actually paid (final).
    // Never recompute from a % — Shopify already applied the discount.
    let savingsCents;
    if (cfg.savingsScope === 'cart' && cart) {
      // Whole-cart savings = original total minus what's actually paid — the
      // exact number the cart drawer shows ("You saved"). Both fields are in /cart.js.
      savingsCents = Math.max(0, (cart.original_total_price || 0) - (cart.total_price || 0));
    } else {
      const subtotal = items.reduce(function (s, it) { return s + (it.price || 0); }, 0);
      const paidTotal = items.reduce(function (s, it) {
        return s + (it.finalPrice != null ? it.finalPrice : (it.price || 0));
      }, 0);
      savingsCents = Math.max(0, subtotal - paidTotal);
    }

    // ----- Headline -----
    const headlineEl = el.querySelector('[data-bpb-headline]');
    if (headlineEl) {
      headlineEl.textContent = (cfg.headlines[tier] || cfg.headlines[0])
        .replace('{savings}', formatMoney(savingsCents))
        .replace('{next}', String(Math.max(0, BUNDLE_MAX - count)));
    }

    // ----- Savings line (always shown) -----
    const savingsAmt = el.querySelector('[data-bpb-savings-amount]');
    if (savingsAmt) savingsAmt.textContent = formatMoney(savingsCents);

    // ----- Native Add-to-Cart button: variant price + delivery subtext -----
    updateButton(cfg);
  }

  // The header's server-rendered <cart-count> lets us skip the initial /cart.js
  // fetch entirely for visitors with an empty cart (most page views).
  function domCartIsEmpty() {
    const counts = document.querySelectorAll('cart-count');
    if (!counts.length) return false;
    return Array.from(counts).every(function (el) { return (parseInt(el.textContent, 10) || 0) === 0; });
  }

  let lastCart = null;
  let refreshing = false;
  async function refresh(cartFromEvent, force) {
    if (refreshing) return;
    // The popup/theme dispatch the same cart object on both the pubsub and the
    // cart:updated channels — skip the duplicate render.
    if (!force && cartFromEvent && cartFromEvent === lastCart) return;
    refreshing = true;
    try {
      let cart = cartFromEvent && Array.isArray(cartFromEvent.items) ? cartFromEvent : null;
      if (!cart && lastCart === null && domCartIsEmpty()) {
        cart = { items: [], item_count: 0, total_price: 0 };
      }
      if (!cart) {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        cart = await res.json();
      }
      lastCart = cart;
      const els = currentInstances();
      const cfgs = els.map(readConfig);

      // If any instance filters by tag, resolve tags first (cached after first
      // lookup). Only items whose product_type matches a bar's filter need a
      // tag check — don't fetch /products/{handle}.js for the rest of the cart.
      if (cfgs.some(function (c) { return c.matchTag; })) {
        const types = cfgs.map(function (c) { return c.matchType; });
        const handles = (cart.items || [])
          .filter(function (it) { return types.indexOf((it.product_type || '').toLowerCase()) !== -1; })
          .map(function (it) { return it.handle; });
        await prefetchTags(handles);
      }

      els.forEach(function (el, i) {
        const cfg = cfgs[i];
        const items = flattenMatchingItems(cart, cfg.matchType, cfg.saleVariants, cfg.matchTag);
        render(el, items, cart);
      });
    } catch (e) {
      // network failures non-critical — bar holds last known state
    } finally {
      refreshing = false;
    }
  }

  instances.forEach(wireToggle);
  instances.forEach(wireClose);

  // Find the current set of [data-bundle-progress] elements (re-query each time
  // because Shopify section re-renders can replace the DOM).
  function currentInstances() {
    return Array.from(document.querySelectorAll('[data-bundle-progress]'));
  }

  function tryMountAll() {
    cleanupOrphans();

    // On mobile width, undo the sidebar class so plain .bpb--sticky CSS applies.
    // Also rescue any bar that was previously moved into a sticky-wrapper at a
    // wider viewport — pull it back out so layout/containing-block oddities
    // can't keep it from pinning to the viewport bottom.
    if (window.innerWidth < DESKTOP_MIN) {
      document.querySelectorAll('sticky-element.bpb-sticky-wrapper').forEach(function (w) {
        const bar = w.querySelector('[data-bundle-progress]');
        if (bar) {
          // Hoist the bar to <body> so it has no transformed/contained ancestor
          // and position:fixed always references the viewport.
          document.body.appendChild(bar);
        }
        w.remove();
      });
      currentInstances().forEach(function (el) {
        el.classList.remove('bpb--in-sidebar');
      });
      return true;
    }

    if (!document.querySelector('.collection__content')) return false;

    currentInstances().forEach(function (el) {
      if (el.classList.contains('bpb--desktop-sidebar-left') ||
          el.classList.contains('bpb--desktop-sidebar-right')) {
        mountAsSidebar(el);
      }
    });
    return true;
  }

  if (!tryMountAll()) {
    let tries = 0;
    const iv = setInterval(function () {
      if (tryMountAll() || ++tries > 20) clearInterval(iv);
    }, 150);
  }

  // Re-evaluate on viewport changes (theme editor toggling mobile/desktop
  // preview, real device rotation, window resize).
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(tryMountAll, 200);
  });

  // Theme editor: react when sections are reloaded or unloaded so we don't
  // accumulate duplicate bars or leave orphan wrappers behind.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-bundle-progress]')) {
      // Re-wire event listeners for the new instance, then re-run mount.
      const fresh = currentInstances();
      fresh.forEach(function (el) {
        if (!el.dataset.bpbWired) {
          wireToggle(el);
          wireClose(el);
          el.dataset.bpbWired = '1';
        }
      });
      setTimeout(tryMountAll, 50);
      setTimeout(applyTabVisibility, 60);
    }
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(tryMountAll, 50);
  });

  // Tag initial instances so we don't re-wire on edit
  instances.forEach(function (el) { el.dataset.bpbWired = '1'; });

  document.addEventListener('cart:updated', function (e) {
    refresh(e && e.detail && e.detail.cart);
  });

  // Variant-aware pricing: when the shopper picks a different size (e.g. XXL),
  // update every bar's base price to the new variant and re-render. The per-tier
  // prices and the button price both flow from cfg.productPrice ← data-product-price.
  function onVariantChange(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    currentInstances().forEach(function (el) {
      el.dataset.productPrice = String(variant.price);
    });
    // Picking a size doesn't change the cart — re-render from the cached cart
    // instead of refetching /cart.js (falls back to a fetch before first load).
    refresh(lastCart, true);
  }
  // Native CustomEvent fallback (theme dispatches `variant:change` on the form/document).
  document.addEventListener('variant:change', function (e) {
    onVariantChange(e && e.detail && e.detail.variant);
  });

  let pubsubSubscribed = false;
  function trySubscribePubsub() {
    if (pubsubSubscribed) return true;
    if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
      pubsubSubscribed = true;
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        refresh(payload && payload.cart);
      });
      if (theme.pubsub.PUB_SUB_EVENTS.variantChange) {
        theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, function (payload) {
          onVariantChange(payload && payload.data && payload.data.variant);
        });
      }
      return true;
    }
    return false;
  }
  // theme.js (which defines theme.pubsub) is a deferred head script, so it has
  // normally run before this deferred section script. If not, retry at the two
  // lifecycle points instead of polling every 250ms; the document-level
  // cart:updated listener above stays as the permanent fallback.
  if (!trySubscribePubsub()) {
    document.addEventListener('DOMContentLoaded', trySubscribePubsub, { once: true });
    window.addEventListener('load', trySubscribePubsub, { once: true });
  }

  // --- Tab-restricted visibility -------------------------------------------
  // Instances limited to one collection "category tab" via data-only-tab.
  // The category tabs swap products via AJAX and fire `collection:reloaded`
  // on the document; `is-active` is also server-rendered on first load.
  function activeTabTag() {
    const t = document.querySelector('.category-tabs__item.is-active');
    return t ? (t.dataset.tag || '').toLowerCase() : '';
  }
  function applyTabVisibility() {
    const tabsPresent = !!document.querySelector('.category-tabs__item');
    let anyHidden = false;
    currentInstances().forEach(function (el) {
      const only = (el.dataset.onlyTab || '').trim().toLowerCase();
      // No restriction, or no tabs on this page → always visible.
      if (!only || !tabsPresent) { el.classList.remove('bpb--tab-hidden'); return; }
      const hide = activeTabTag() !== only;
      el.classList.toggle('bpb--tab-hidden', hide);
      if (hide) anyHidden = true;
    });
    // Collapse the reserved bottom padding when the bar is hidden by tab.
    document.body.classList.toggle('bpb-bar-hidden', anyHidden);
  }
  document.addEventListener('collection:reloaded', applyTabVisibility);

  refresh();
  applyTabVisibility();

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
})();
